import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'
import { getTitleStyles } from 'plugin-mantine-resources/src/helpers/titleHelpers'

export const Title: MantineThemeComponents['Title'] = {
    styles: (__, props, runtimeProps): Record<string, CSSObject> => {
        return getTitleStyles(runtimeProps.size ?? props.element)
    }
}
